import type { SelectItem } from '@vrplatform/components';

const OWNER_VR_TRUST_GROUP = 'VR Trust';
const OWNER_VR_PLATFORM_GROUP = 'VR Platform';
const OWNER_OTHER_GROUP = 'Other';

const withGroup = <T extends SelectItem>(item: T, group: string): T => ({
  ...item,
  group,
});

const withoutGroup = <T extends SelectItem>(item: T): T => {
  const { group: _group, ...rest } = item;
  return rest as T;
};

const getOwnerProductGroup = (productGroup?: string | null) => {
  if (productGroup === OWNER_VR_TRUST_GROUP) return OWNER_VR_TRUST_GROUP;
  if (productGroup === OWNER_VR_PLATFORM_GROUP) return OWNER_VR_PLATFORM_GROUP;
  return OWNER_OTHER_GROUP;
};

export const groupNavbarOwnerSwitchItems = <
  T extends SelectItem & { productGroup?: string | null },
>(
  items: readonly T[]
) => {
  const groupedItems = [
    OWNER_VR_TRUST_GROUP,
    OWNER_VR_PLATFORM_GROUP,
    OWNER_OTHER_GROUP,
  ].flatMap((group) =>
    items
      .filter((item) => getOwnerProductGroup(item.productGroup) === group)
      .map((item) => withGroup(item, group))
  );

  const visibleGroups = new Set(groupedItems.map((item) => item.group));

  if (visibleGroups.size < 2) {
    return items.map(withoutGroup);
  }

  return groupedItems;
};

/**
 * Which team the owner profile switch is limited to. A custom owner portal
 * shows only its registered team; preview mode shows the previewed team; every
 * other case lists all accessible owner profiles.
 */
export function resolveOwnerSwitchScopedTeamId(args: {
  isUserPreview: boolean;
  portalTeamId: string | undefined;
  teamId: string | null | undefined;
}): string | null {
  if (args.portalTeamId) return args.portalTeamId;
  return args.isUserPreview ? (args.teamId ?? null) : null;
}
